import script from "./giantPage.vue?vue&type=script&setup=true&lang=js"
export * from "./giantPage.vue?vue&type=script&setup=true&lang=js"

import "./giantPage.vue?vue&type=style&index=0&id=0557a2a1&lang=scss&scoped=true"

import exportComponent from "/jenkins/workspace/zh-operate-subapp_prev/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0557a2a1"]])

export default __exports__